/* ============================================================
   SOVEREIGN HOUSE — Global Interactivity
   sst-script.js: nav, reveal, ticker, chart, modal, forms
   ============================================================ */
(function () {
  'use strict';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const fmt = (n, d = 0) => n.toLocaleString('en-GB', { minimumFractionDigits: d, maximumFractionDigits: d });
 
  /* ============================================================
     STICKY NAV
     ============================================================ */
  const nav = $('#sst-nav');
  if (nav) {
    let navTicking = false;
    let navSolid = false;
    const onScroll = () => {
      navTicking = false;
      const should = navSolid ? window.scrollY > 16 : window.scrollY > 48;
      if (should !== navSolid) {
        navSolid = should;
        nav.classList.toggle('sst-nav--solid', navSolid);
      }
    };
    window.addEventListener('scroll', () => {
      if (!navTicking) { navTicking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    onScroll();
  }

  /* ============================================================
     MOBILE DRAWER (hamburger → right-side menu)
     ============================================================ */
  const burger = $('[data-sst-burger]');
  const drawer = $('[data-sst-drawer]');
  if (burger && drawer) {
    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('sst-drawer-open');
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sst-drawer-open');
    };
    burger.addEventListener('click', openDrawer);
    $$('[data-sst-drawer-close]', drawer).forEach((el) => el.addEventListener('click', closeDrawer));
    $$('.sst-drawer__links a', drawer).forEach((a) => a.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ============================================================
     SCROLL REVEAL
     ============================================================ */
  const reveals = Array.from(document.querySelectorAll('.sst-reveal'));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function enableScrollReveal() {
    let ticking = false;
    let pending = reveals.slice();
    const check = () => {
      ticking = false;
      const vh = window.innerHeight || document.documentElement.clientHeight;
      for (let i = pending.length - 1; i >= 0; i--) {
        const r = pending[i].getBoundingClientRect();
        if (r.top < vh * 0.92 && r.bottom > 0) {
          pending[i].classList.add('sst-in');
          pending.splice(i, 1);
        }
      }
    };
    const onSR = () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
    window.addEventListener('scroll', onSR, { passive: true });
    window.addEventListener('resize', onSR, { passive: true });
    check();
  }

  if (reduceMotion) {
    document.documentElement.classList.add('sst-no-reveal');
  } else {
    const probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;left:-9999px;top:0;width:6px;height:6px;opacity:0.02;transition:opacity .12s linear;pointer-events:none';
    document.body.appendChild(probe);
    probe.getBoundingClientRect();
    probe.style.opacity = '1';
    setTimeout(() => {
      const ok = parseFloat(getComputedStyle(probe).opacity) > 0.5;
      probe.remove();
      if (ok) enableScrollReveal();
      else document.documentElement.classList.add('sst-no-reveal');
    }, 220);
  }

  /* ============================================================
     GOLD PRICE — LIVE DATA  (metals.dev, paid plan)
     Live spot:  /metal/spot?metal=gold&currency=GBP → rate.price (GBP/toz),
       rate.change_percent (real 24H %), rate.high / rate.low (24H range).
     Chart: /timeseries — note the API IGNORES currency= for the metal
       value (gold is always returned in USD) but gives a per-day USD→GBP in
       rates[day].currencies.GBP. Real GBP gold = metals.gold × currencies.GBP.
       metals.dev caps timeseries calls at 30 days. The site fetches 10Y once
       and derives shorter ranges locally to conserve API quota.
     NOTE: api_key is exposed in client-side JS. If abused, rotate the key on
       metals.dev or move these calls behind a server proxy.
     ============================================================ */
  const GOLD = {
    KEY:      '8WQPZYCHNLLXPURWAXJ8959RWAXJ8',
    spot:     'https://api.metals.dev/v1/metal/spot',
    series:   'https://api.metals.dev/v1/timeseries',
    POLL_MS:  24 * 3600 * 1000, // 24h — conserves API quota
    SPOT_TTL: 24 * 3600 * 1000, // cache live spot 24h per browser
    LONG_HIST_TTL: 24 * 3600 * 1000, // cache 10Y history 24h per browser
    MAX_SERIES_DAYS: 30,
  };

  // base = reference price for the % change (the first reading this session).
  const market = { gold: { price: 1952.79, changePct: 0, high: 0, low: 0 } };

  const ymd = (d) => d.toISOString().slice(0, 10);

  async function getJSON(url) {
    const r = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url);
    return r.json();
  }

  // Live GBP spot per troy oz, with real 24H change + range from metals.dev.
  async function fetchSpotGBP() {
    const url = `${GOLD.spot}?api_key=${GOLD.KEY}&metal=gold&currency=GBP`;
    const j = await getJSON(url);
    const r = j.rate || {};
    return {
      price: r.price,
      changePct: typeof r.change_percent === 'number' ? r.change_percent : 0,
      high: r.high || 0,
      low: r.low || 0,
    };
  }

  function readCachedSpot() {
    try {
      const raw = localStorage.getItem('sst-gold-spot');
      if (!raw) return null;
      const c = JSON.parse(raw);
      if (Date.now() - c.t < GOLD.SPOT_TTL && c.v && c.v.price > 0) return c.v;
    } catch (e) { /* ignore cache errors */ }
    return null;
  }

  function writeCachedSpot(d) {
    try { localStorage.setItem('sst-gold-spot', JSON.stringify({ t: Date.now(), v: d })); } catch (e) {}
  }

  function paintTicker() {
    document.querySelectorAll('.sst-tick').forEach((t) => {
      const m = market[t.dataset.metal];
      if (!m) return;
      const px = t.querySelector('[data-px]');
      const chg = t.querySelector('[data-chg]');
      if (px) px.textContent = '£' + fmt(m.price, 2);
      if (chg) {
        const pct = m.changePct;
        chg.textContent = (pct >= 0 ? '+' : '−') + Math.abs(pct).toFixed(2) + '%';
        chg.className = 'sst-chg ' + (pct >= 0 ? 'up' : 'dn');
      }
      t.classList.add('sst-flash');
      setTimeout(() => t.classList.remove('sst-flash'), 600);
    });

    const spotEl = document.querySelector('[data-spot]');
    if (spotEl) spotEl.textContent = fmt(market.gold.price, 2);

    const pct24 = market.gold.changePct;
    const el24 = document.querySelector('[data-24h]');
    if (el24) {
      el24.textContent = (pct24 >= 0 ? '+' : '−') + Math.abs(pct24).toFixed(2) + '%';
      el24.className = 'sst-v ' + (pct24 >= 0 ? 'up' : 'dn');
      el24.classList.remove('sst-v--loading');
    }

  }

  /* ============================================================
     PRICE CHART
     ============================================================ */
  const W = 600, H = 240, PADX = 6, PADY = 18;
  const DAY_MS = 86400000;
  let currentRange = '1Y';

  const rangeLabels = {
    '1Y': 'Last 1 year',
    '5Y': 'Last 5 years',
    '10Y': 'Last 10 years',
  };

  const rangeConfig = {
    '1Y': { days: 365, maxPoints: 180 },
    '5Y': { days: 365 * 5, maxPoints: 240 },
    '10Y': { days: 365 * 10, cacheKey: 'sst-gold-10y', ttl: GOLD.LONG_HIST_TTL, maxPoints: 280 },
  };

  // metals.dev is daily-only (no intraday). A single 10Y history load feeds all
  // shorter ranges locally, avoiding duplicate 1Y/5Y requests.
  const series = {
    '1Y': [],
    '5Y': [],
    '10Y': [],
  };
  const rangeRequests = {};

  function readCachedRange(cfg) {
    try {
      const raw = localStorage.getItem(cfg.cacheKey);
      if (raw) {
        const c = JSON.parse(raw);
        if (Date.now() - c.t < cfg.ttl && Array.isArray(c.v) && c.v.length) return c.v;
      }
    } catch (e) { /* ignore cache errors */ }
    return null;
  }

  function writeCachedRange(cfg, arr) {
    try { localStorage.setItem(cfg.cacheKey, JSON.stringify({ t: Date.now(), v: arr })); } catch (e) {}
  }

  function downsampleRange(arr, maxPoints) {
    if (!Array.isArray(arr) || arr.length <= maxPoints) return arr.slice();
    const out = [];
    const step = (arr.length - 1) / (maxPoints - 1);
    for (let i = 0; i < maxPoints; i++) out.push(arr[Math.round(i * step)]);
    out[0] = arr[0];
    out[out.length - 1] = arr[arr.length - 1];
    return out;
  }

  function parseHistoryRates(hist) {
    return Object.keys(hist.rates || {}).sort()
      .map((day) => {
        const d = hist.rates[day];
        const gold = d && d.metals ? d.metals.gold : 0;
        const gbp = d && d.currencies ? d.currencies.GBP : 0;
        return gbp > 0 ? gold / gbp : 0;
      })
      .filter((v) => v > 0);
  }

  async function fetchHistoryDays(days) {
    const end = new Date();
    const start = new Date(end.getTime() - (days - 1) * DAY_MS);
    const arr = [];
    let chunkStart = new Date(start);
    while (chunkStart <= end) {
      const chunkEnd = new Date(Math.min(
        chunkStart.getTime() + (GOLD.MAX_SERIES_DAYS - 1) * DAY_MS,
        end.getTime()
      ));
      const url = `${GOLD.series}?api_key=${GOLD.KEY}&start_date=${ymd(chunkStart)}&end_date=${ymd(chunkEnd)}&currency=GBP&unit=toz`;
      const hist = await getJSON(url);
      arr.push(...parseHistoryRates(hist));
      chunkStart = new Date(chunkEnd.getTime() + DAY_MS);
    }
    return arr;
  }

  function updateRangeStat(attr, arr) {
    const el = document.querySelector('[data-' + attr + ']');
    if (!el || !Array.isArray(arr) || arr.length < 2) return;
    const first = arr[0], last = arr[arr.length - 1];
    if (first <= 0) return;
    const pct = ((last - first) / first) * 100;
    el.textContent = (pct >= 0 ? '+' : '−') + Math.abs(pct).toFixed(2) + '%';
    el.className = 'sst-v ' + (pct >= 0 ? 'up' : 'dn');
    el.classList.remove('sst-v--loading');
  }

  function applyHistoryRange(range, arr) {
    const cfg = rangeConfig[range];
    if (!cfg || !Array.isArray(arr) || arr.length < 2) return;
    series[range] = downsampleRange(arr, cfg.maxPoints);
    if (range === '1Y') updateRangeStat('1y', arr);
    if (range === '5Y') updateRangeStat('5y', arr);
    if (range === '10Y') updateRangeStat('10y', arr);
    if (range === currentRange) drawChart();
  }

  function sliceHistoryRange(arr, range) {
    const cfg = rangeConfig[range];
    if (!cfg || !Array.isArray(arr)) return [];
    return arr.slice(-cfg.days);
  }

  function applyHistoryDataset(arr) {
    if (!Array.isArray(arr) || arr.length < 2) return;
    applyHistoryRange('1Y', sliceHistoryRange(arr, '1Y'));
    applyHistoryRange('5Y', sliceHistoryRange(arr, '5Y'));
    applyHistoryRange('10Y', arr);
  }

  async function loadHistoryRange(range) {
    const targetCfg = rangeConfig['10Y'];
    if (!targetCfg || !rangeConfig[range]) return;
    const cached = readCachedRange(targetCfg);
    if (cached) {
      applyHistoryDataset(cached);
      return;
    }
    try {
      const arr = await fetchHistoryDays(targetCfg.days);
      if (arr.length > 1) {
        writeCachedRange(targetCfg, arr);
        applyHistoryDataset(arr);
      }
    } catch (e) { /* keep chart empty if history unavailable */ }
  }

  async function ensureRange(range) {
    if (series[range] && series[range].length > 1) return;
    if (!rangeRequests['10Y']) {
      rangeRequests['10Y'] = loadHistoryRange(range)
        .finally(() => { delete rangeRequests['10Y']; });
    }
    await rangeRequests['10Y'];
  }

  const linePath = $('#sst-linePath');
  const areaPath = $('#sst-areaPath');
  const dot = $('#sst-dot');
  const grid = $('#sst-gridLines');
  const rangeLabel = document.querySelector('[data-range-label]');
  const loadNote = document.querySelector('[data-load-note]');
  const loEl = document.querySelector('[data-lo]');
  const hiEl = document.querySelector('[data-hi]');
  const chartSvg = linePath ? linePath.closest('svg') : null;

  function setChartLoading(isLoading, range = currentRange) {
    if (rangeLabel) {
      rangeLabel.textContent = isLoading
        ? 'Loading ' + rangeLabels[range].toLowerCase() + '...'
        : rangeLabels[range];
    }
    if (loadNote) {
      if (isLoading) loadNote.removeAttribute('hidden');
      else loadNote.setAttribute('hidden', '');
    }
    if (rangeToggle) {
      rangeToggle.querySelectorAll('button').forEach((x) => { x.disabled = isLoading; });
    }
  }

  // Tooltip SVG elements — created once, reused.
  const ns = 'http://www.w3.org/2000/svg';
  const ttGroup = document.createElementNS(ns, 'g');
  ttGroup.setAttribute('id', 'sst-tooltip');
  ttGroup.style.pointerEvents = 'none';
  ttGroup.style.display = 'none';
  const ttRect = document.createElementNS(ns, 'rect');
  ttRect.setAttribute('rx', '4');
  ttRect.setAttribute('fill', 'var(--sst-navy-900, #0d1829)');
  ttRect.setAttribute('stroke', 'rgba(216,189,134,0.35)');
  ttRect.setAttribute('stroke-width', '1');
  const ttText = document.createElementNS(ns, 'text');
  ttText.setAttribute('fill', 'var(--sst-gold-bright, #d8bd86)');
  ttText.setAttribute('font-size', '13');
  ttText.setAttribute('font-family', 'inherit');
  ttText.setAttribute('font-weight', '600');
  ttText.setAttribute('text-anchor', 'middle');
  ttText.setAttribute('dominant-baseline', 'middle');
  const ttDot = document.createElementNS(ns, 'circle');
  ttDot.setAttribute('r', '4');
  ttDot.setAttribute('fill', 'var(--sst-gold-bright, #d8bd86)');
  ttDot.setAttribute('stroke', 'var(--sst-navy-900, #0d1829)');
  ttDot.setAttribute('stroke-width', '2');
  ttGroup.appendChild(ttRect);
  ttGroup.appendChild(ttText);
  ttGroup.appendChild(ttDot);
  if (chartSvg) chartSvg.appendChild(ttGroup);

  // Store current chart pts + data for hover lookup.
  let chartPts = [], chartData = [];

  function showTooltip(px, py, price) {
    const label = '£' + fmt(price, 0);
    ttText.textContent = label;
    const TW = label.length * 8 + 16, TH = 22;
    // keep tooltip inside SVG viewBox (W=600)
    const tx = Math.min(Math.max(px, TW / 2 + 2), W - TW / 2 - 2);
    const ty = py - 28 < PADY ? py + 28 : py - 28;
    ttRect.setAttribute('x', tx - TW / 2); ttRect.setAttribute('y', ty - TH / 2);
    ttRect.setAttribute('width', TW); ttRect.setAttribute('height', TH);
    ttText.setAttribute('x', tx); ttText.setAttribute('y', ty);
    ttDot.setAttribute('cx', px); ttDot.setAttribute('cy', py);
    ttGroup.style.display = '';
  }

  function drawChart() {
    if (!linePath) return;
    const data = series[currentRange];
    if (!data || data.length < 2) return;
    const min = Math.min(...data), max = Math.max(...data);
    const range = (max - min) || 1;
    const innerW = W - PADX * 2, innerH = H - PADY * 2;
    const pts = data.map((v, i) => {
      const x = PADX + (i / (data.length - 1)) * innerW;
      const y = PADY + innerH - ((v - min) / range) * innerH;
      return [x, y];
    });
    chartPts = pts; chartData = data;
    const d = pts.map((p, i) => (i === 0 ? 'M' : 'L') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' ');
    linePath.setAttribute('d', d);
    if (areaPath) areaPath.setAttribute('d', d + ` L${(W - PADX).toFixed(1)} ${H - PADY} L${PADX} ${H - PADY} Z`);
    if (dot) { dot.setAttribute('cx', pts[pts.length - 1][0]); dot.setAttribute('cy', pts[pts.length - 1][1]); }
    if (grid) {
      grid.innerHTML = '';
      for (let i = 0; i <= 3; i++) {
        const y = PADY + (innerH / 3) * i;
        const ln = document.createElementNS(ns, 'line');
        ln.setAttribute('x1', PADX); ln.setAttribute('x2', W - PADX);
        ln.setAttribute('y1', y); ln.setAttribute('y2', y);
        ln.setAttribute('stroke', 'var(--sst-line-dark)'); ln.setAttribute('stroke-width', '1');
        ln.setAttribute('vector-effect', 'non-scaling-stroke');
        grid.appendChild(ln);
      }
    }
    if (rangeLabel) rangeLabel.textContent = rangeLabels[currentRange];
    if (loEl) loEl.textContent = 'Low £' + fmt(min, 0);
    if (hiEl) hiEl.textContent = 'High £' + fmt(max, 0);
    // Show last point tooltip always (acts as default/mobile state).
    const last = pts[pts.length - 1];
    showTooltip(last[0], last[1], data[data.length - 1]);
  }

  // Hover: find nearest point by x distance in SVG coordinate space.
  if (chartSvg) {
    chartSvg.addEventListener('mousemove', (e) => {
      if (!chartPts.length) return;
      const rect = chartSvg.getBoundingClientRect();
      const mx = ((e.clientX - rect.left) / rect.width) * W;
      let closest = 0, minDist = Infinity;
      chartPts.forEach(([px], i) => {
        const dist = Math.abs(px - mx);
        if (dist < minDist) { minDist = dist; closest = i; }
      });
      showTooltip(chartPts[closest][0], chartPts[closest][1], chartData[closest]);
    });
    chartSvg.addEventListener('mouseleave', () => {
      // Revert to last-point tooltip on mouse out.
      if (chartPts.length) {
        const last = chartPts[chartPts.length - 1];
        showTooltip(last[0], last[1], chartData[chartData.length - 1]);
      }
    });
  }

  const rangeToggle = $('#sst-rangeToggle');
  if (rangeToggle) {
    rangeToggle.querySelectorAll('button').forEach((b) => {
      b.addEventListener('click', async () => {
        const nextRange = b.dataset.range;
        const previousRange = currentRange;
        rangeToggle.querySelectorAll('button').forEach((x) => x.classList.remove('active'));
        b.classList.add('active');
        currentRange = nextRange;
        if (!series[currentRange] || series[currentRange].length < 2) {
          setChartLoading(true, currentRange);
          await ensureRange(currentRange);
          setChartLoading(false, currentRange);
        }
        if (!series[currentRange] || series[currentRange].length < 2) {
          currentRange = previousRange;
          rangeToggle.querySelectorAll('button').forEach((x) => {
            x.classList.toggle('active', x.dataset.range === currentRange);
          });
          if (rangeLabel) rangeLabel.textContent = 'Unable to load range';
          return;
        }
        if (linePath) {
          linePath.style.transition = 'none';
          drawChart();
          const len = linePath.getTotalLength ? linePath.getTotalLength() : 0;
          if (len) {
            linePath.style.strokeDasharray = len;
            linePath.style.strokeDashoffset = len;
            requestAnimationFrame(() => {
              linePath.style.transition = 'stroke-dashoffset .8s ease';
              linePath.style.strokeDashoffset = 0;
            });
          }
        }
      });
    });
  }

  /* ============================================================
     MODAL
     ============================================================ */
  const modalScrim   = $('#sst-modal');
  const modalForm    = $('#sst-modalForm');
  const modalSuccess = $('#sst-modalSuccess');
  const modalTitle   = $('#sst-modalTitle');
  const modalKicker  = $('#sst-modalKicker');
  const modalIntro   = $('#sst-modalIntro');
  const modalSuccMsg = $('#sst-modalSuccessMsg');
  const modalReturnTo = $('#sst-mReturnTo');
  const modalMessageLabel = $('#sst-mMessageLabel');
  const modalMessage = $('#sst-mMessage');
  const MODAL_SUCCESS_KEY = 'sstModalEnquirySuccess';
  let lastFocus = null;

  function openModal({
    title,
    kicker,
    intro,
    successMsg,
    product = '',
    enquiryType = 'Advisor Consultation',
    messageLabel = 'Let us know what you’d like to discuss with an advisor.',
    messagePlaceholder = 'Let us know what you’d like to discuss with an advisor.',
  }) {
    if (!modalScrim) return;
    if (modalTitle)   modalTitle.textContent  = title;
    if (modalKicker)  modalKicker.textContent  = kicker;
    if (modalIntro)   modalIntro.textContent   = intro;
    if (modalSuccMsg) modalSuccMsg.textContent = successMsg;
    if (modalMessageLabel) modalMessageLabel.textContent = messageLabel;
    if (modalMessage) modalMessage.placeholder = messagePlaceholder;
    if (modalForm) {
      modalForm.style.display = '';
      modalForm.reset();
      // reset() doesn't fire input events; nudge the phone gate to re-disable the button.
      modalForm.querySelectorAll('input[type="tel"]').forEach((tel) => {
        tel.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }
    if (modalReturnTo) modalReturnTo.value = window.location.pathname + '?contact_posted=true';
    const enquiryTypeField = $('#sst-mEnquiryType');
    if (enquiryTypeField) enquiryTypeField.value = enquiryType;
    const productField = $('#sst-mProduct');
    if (productField) productField.value = product || 'General advisor request';
    if (modalSuccess) modalSuccess.classList.remove('show');
    document.querySelectorAll('.sst-fg', modalForm).forEach((fg) => fg.classList.remove('invalid'));
    lastFocus = document.activeElement;
    modalScrim.classList.add('show');
    document.body.style.overflow = 'hidden';
    setTimeout(() => { const f = $('#sst-mName'); if (f) f.focus(); }, 60);
  }

  function closeModal() {
    if (!modalScrim) return;
    modalScrim.classList.remove('show');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  const modalClose = $('#sst-modalClose');
  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalScrim) modalScrim.addEventListener('click', (e) => { if (e.target === modalScrim) closeModal(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modalScrim && modalScrim.classList.contains('show')) closeModal(); });

  document.querySelectorAll('[data-open-advisor]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    openModal({
      title: 'Speak With An Advisor',
      kicker: 'Private Consultation',
      intro: 'Leave your details and a dedicated advisor will call you back, usually within one working hour.',
      successMsg: 'An advisor will be in touch very shortly. We look forward to speaking with you.',
      product: 'General advisor request',
      enquiryType: 'Advisor Consultation',
      messageLabel: 'Let us know what you’d like to discuss with an advisor.',
      messagePlaceholder: 'Let us know what you’d like to discuss with an advisor.',
    });
  }));

  document.querySelectorAll('[data-enquire]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    const item = b.dataset.enquire;
    openModal({
      title: 'Enquire — ' + item,
      kicker: 'Private Enquiry',
      intro: 'Register your interest in the ' + item + '. An advisor will confirm live pricing, availability and answer any questions.',
      successMsg: 'Thank you. An advisor will be in touch shortly with live pricing and availability for the ' + item + '.',
      product: item,
      enquiryType: 'Product Enquiry',
      messageLabel: 'What would you like to know?',
      messagePlaceholder: 'What would you like to know?',
    });
  }));

  /* ============================================================
     FORM VALIDATION
     ============================================================ */
  const emailRx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function validateField(input) {
    const fg = input.closest('.sst-fg');
    let ok = true;
    const val = input.value.trim();
    if (input.hasAttribute('required') && !val) ok = false;
    if (input.type === 'email' && val && !emailRx.test(val)) ok = false;
    if (input.type === 'tel' && (val || input.hasAttribute('required'))) {
      const digits = normalisePhone(val);
      // National number must be 9-10 digits (country code excluded).
      if (digits.length < MIN_PHONE_DIGITS || digits.length > MAX_PHONE_DIGITS) ok = false;
      // Reject obviously fake patterns: all same digit.
      if (ok && /^(\d)\1+$/.test(digits)) ok = false;
    }
    if (fg) fg.classList.toggle('invalid', !ok);
    return ok;
  }

  // Prepend the selected country dial code to a phone input's value before submit,
  // so Shopify stores/emails the full international number (e.g. +447700900000).
  function wirePhoneCountryCode(form) {
    if (!form) return;
    form.querySelectorAll('.sst-phone-group').forEach((group) => {
      const select = group.querySelector('.sst-cc-select');
      const tel = group.querySelector('input[type="tel"]');
      if (!select || !tel) return;
      form.addEventListener('submit', () => {
        const digits = normalisePhone(tel.value);
        if (digits) tel.value = '+' + select.value + digits;
      });
    });
  }

  // National number length (excluding country code). UK entered with a leading 0
  // (07700900000) is stripped to 10; without the 0 it is 9-10. Spaces/symbols are
  // stripped on input so the field only ever holds digits.
  const MIN_PHONE_DIGITS = 9;
  const MAX_PHONE_DIGITS = 10;

  // Keep only digits, drop a single leading 0, cap at MAX so the field can never
  // exceed the allowed national length.
  function normalisePhone(raw) {
    return raw.replace(/\D/g, '').replace(/^0/, '').slice(0, MAX_PHONE_DIGITS);
  }

  // True when a single field currently holds an acceptable value.
  function fieldReady(inp) {
    const val = inp.value.trim();
    if (inp.type === 'tel') {
      const digits = normalisePhone(inp.value);
      return digits.length >= MIN_PHONE_DIGITS && digits.length <= MAX_PHONE_DIGITS;
    }
    if (inp.type === 'checkbox') return !inp.hasAttribute('required') || inp.checked;
    if (inp.hasAttribute('required') && !val) return false;
    if (inp.type === 'email' && val && !emailRx.test(val)) return false;
    return true;
  }

  // Keep the submit button disabled until every required/validated field in the
  // form is acceptable: required fields filled, email well-formed, phone 9-10 digits.
  function wirePhoneGate(form) {
    if (!form) return;
    const btn = form.querySelector('button[type=submit]');
    if (!btn) return;
    const fields = Array.from(form.querySelectorAll(
      'input[required], input[type=email], input[type=tel], textarea[required]'
    ));
    const refresh = () => {
      btn.disabled = !fields.every(fieldReady);
    };
    fields.forEach((inp) => {
      if (inp.type === 'tel') {
        // Strip anything that isn't a digit (blocks spaces) as the user types.
        inp.addEventListener('input', () => {
          const cleaned = normalisePhone(inp.value);
          if (inp.value !== cleaned) inp.value = cleaned;
          refresh();
        });
        // Block the space key outright for good measure.
        inp.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.code === 'Space') e.preventDefault();
        });
      } else {
        inp.addEventListener('input', refresh);
      }
      inp.addEventListener('change', refresh);
      inp.addEventListener('blur', refresh);
    });
    refresh();
  }

  // Submit Shopify customer forms without a full page reload.
  // Contact forms submit natively so Shopify's captcha flow can run.
  function showFormSuccess(form, successEl) {
    if (form) form.style.display = 'none';
    if (!successEl) return;
    successEl.classList.add('show');
    successEl.setAttribute('tabindex', '-1');
    successEl.focus({ preventScroll: true });
  }

  function submitInHiddenFrame(form, successEl) {
    const frameName = 'sst-form-fallback-' + Date.now();
    const iframe = document.createElement('iframe');
    const previousTarget = form.getAttribute('target');
    let finished = false;

    iframe.name = frameName;
    iframe.style.display = 'none';
    iframe.setAttribute('aria-hidden', 'true');
    document.body.appendChild(iframe);
    form.setAttribute('target', frameName);

    const finish = () => {
      if (finished) return;
      finished = true;
      if (previousTarget === null) form.removeAttribute('target');
      else form.setAttribute('target', previousTarget);
      showFormSuccess(form, successEl);
      setTimeout(() => iframe.remove(), 1000);
    };

    iframe.addEventListener('load', finish, { once: true });
    HTMLFormElement.prototype.submit.call(form);
    setTimeout(finish, 2500);
  }

  function wireForm(form, successEl, options = {}) {
    if (!form) return;
    form.querySelectorAll('input[required], input[type=email], input[type=tel]').forEach((inp) => {
      inp.addEventListener('blur', () => validateField(inp));
      inp.addEventListener('input', () => {
        const fg = inp.closest('.sst-fg');
        if (fg && fg.classList.contains('invalid')) validateField(inp);
      });
    });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      let allOk = true;
      form.querySelectorAll('input[required], input[type=email], input[type=tel]').forEach((inp) => {
        if (!validateField(inp)) allOk = false;
      });
      // required checkbox (consent)
      form.querySelectorAll('input[type=checkbox][required]').forEach((cb) => {
        if (!cb.checked) { allOk = false; const fg = cb.closest('.sst-consent'); if (fg) fg.classList.add('invalid'); }
      });
      if (!allOk) { const first = form.querySelector('.sst-fg.invalid input'); if (first) first.focus(); return; }

      const btn = form.querySelector('button[type=submit]');
      const orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Sending…'; btn.disabled = true; }

      const action = form.getAttribute('action') || '/contact';
      fetch(action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' },
      })
        .then((res) => {
          // Shopify redirects on success; fetch follows it and returns ok.
          if (!res.ok) throw new Error('Submission failed');
          showFormSuccess(form, successEl);
        })
        .catch(() => {
          if (options.preservePageOnFallback) {
            submitInHiddenFrame(form, successEl);
            return;
          }
          // Fallback: native submit so the visitor still reaches Shopify's handler.
          HTMLFormElement.prototype.submit.call(form);
        })
        .finally(() => {
          if (btn) { btn.textContent = orig; btn.disabled = false; }
        });
    });
  }

  function showModalSuccess(message) {
    if (!modalScrim) return;
    if (modalTitle) modalTitle.textContent = 'Thank you.';
    if (modalKicker) modalKicker.textContent = 'Request Received';
    if (modalIntro) modalIntro.textContent = '';
    if (modalSuccMsg) {
      modalSuccMsg.textContent = message || 'Thank you. An advisor will be in touch shortly.';
    }
    showFormSuccess(modalForm, modalSuccess);
    modalScrim.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  function wireNativeValidation(form, options = {}) {
    if (!form) return;
    form.querySelectorAll('input[required], input[type=email], input[type=tel]').forEach((inp) => {
      inp.addEventListener('blur', () => validateField(inp));
      inp.addEventListener('input', () => {
        const fg = inp.closest('.sst-fg');
        if (fg && fg.classList.contains('invalid')) validateField(inp);
      });
    });
    form.addEventListener('submit', (e) => {
      let allOk = true;
      form.querySelectorAll('input[required], input[type=email], input[type=tel]').forEach((inp) => {
        if (!validateField(inp)) allOk = false;
      });
      if (!allOk) {
        e.preventDefault();
        const first = form.querySelector('.sst-fg.invalid input');
        if (first) first.focus();
        return;
      }
      if (options.successStorageKey) {
        try {
          sessionStorage.setItem(options.successStorageKey, options.getSuccessMessage ? options.getSuccessMessage() : '');
        } catch (err) {
          // Storage can be unavailable in privacy modes; native submission still works.
        }
      }
    });
  }

  wireForm($('#sst-packForm'), $('#sst-packSuccess'), { preservePageOnFallback: true });
  wireNativeValidation(modalForm, {
    successStorageKey: MODAL_SUCCESS_KEY,
    getSuccessMessage: () => (modalSuccMsg ? modalSuccMsg.textContent : ''),
  });
  wireNativeValidation($('#sst-contactForm'));
  wirePhoneCountryCode($('#sst-packForm'));
  wirePhoneCountryCode(modalForm);
  wirePhoneCountryCode($('#sst-contactForm'));
  wirePhoneGate($('#sst-packForm'));
  wirePhoneGate(modalForm);
  wirePhoneGate($('#sst-contactForm'));

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('customer_posted') === 'true') {
    showFormSuccess($('#sst-packForm'), $('#sst-packSuccess'));
  }
  if (urlParams.get('contact_posted') === 'true') {
    let modalSuccessMessage = '';
    try {
      modalSuccessMessage = sessionStorage.getItem(MODAL_SUCCESS_KEY) || '';
      sessionStorage.removeItem(MODAL_SUCCESS_KEY);
    } catch (err) {
      modalSuccessMessage = '';
    }
    if (modalSuccessMessage) showModalSuccess(modalSuccessMessage);
  }

  /* Scroll to investor pack */
  document.querySelectorAll('[data-open-pack]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    const pack = $('#sst-pack');
    if (pack) window.scrollTo({ top: pack.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    setTimeout(() => {
      const f = $('#sst-pfFirst');
      const pf = $('#sst-packForm');
      if (f && pf && getComputedStyle(pf).display !== 'none') f.focus();
    }, 700);
  }));

  /* ============================================================
     BOOT
     ============================================================ */
  // Apply a fresh live spot reading to the UI.
  // change_percent / high / low come straight from metals.dev (real 24H).
  function applySpot(d) {
    market.gold.price = d.price;
    market.gold.changePct = d.changePct;
    market.gold.high = d.high;
    market.gold.low = d.low;
    paintTicker();
  }

  async function tickLive(force = false) {
    const cached = force ? null : readCachedSpot();
    if (cached) {
      applySpot(cached);
      return;
    }
    try {
      const d = await fetchSpotGBP();
      if (d && d.price > 0) {
        writeCachedSpot(d);
        applySpot(d);
      }
    } catch (e) { /* keep last good value */ }
  }

  // Boot: synchronously paint any cached stats first (instant on repeat visits),
  // then fetch 10Y once and derive shorter ranges locally.
  function bootPaintCachedStats() {
    const cached = readCachedRange(rangeConfig['10Y']);
    if (cached) {
      applyHistoryDataset(cached);
      drawChart();
      return true;
    }
    drawChart();
    return false;
  }

  const hasHistoryUi = Boolean(linePath || document.querySelector('[data-1y], [data-5y], [data-10y]'));

  paintTicker();
  tickLive();
  if (hasHistoryUi) {
    const hasCachedHistory = bootPaintCachedStats();
    if (!hasCachedHistory) setChartLoading(true, currentRange);
    loadHistoryRange('10Y').finally(() => {
      if (series[currentRange] && series[currentRange].length > 1) {
        setChartLoading(false, currentRange);
      } else {
        setChartLoading(false, currentRange);
        if (rangeLabel) rangeLabel.textContent = 'Unable to load range';
      }
    });
  }
  setInterval(() => tickLive(true), GOLD.POLL_MS);

  /* Expose for external use */
  window.__sst = { drawChart, paintTicker };

})();
